export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) {
    window.location.href = `/#${id}`;
    return;
  }
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: id === "start" ? 0 : -72, duration: 1.2, force: true });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const onAnchor = (id, after) => (e) => {
  e.preventDefault();
  after?.();
  if (after) setTimeout(() => scrollToId(id), 120);
  else scrollToId(id);
};
